// extracted by mini-css-extract-plugin
module.exports = {"spinner":"BrandSpinner_spinner__1s9t7","rotate":"BrandSpinner_rotate__QdcCR"};